export default {"src":"/_next/static/media/icon_timer_filled.32a91dca.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};